// Module
var code = "<template>\n    <span title.bind=\"text\">${limitedText}</span>\n</template>\n";
// Exports
export default code;